import { useState, useEffect } from 'react';

// Hook to manage collapsed/expanded state for event months
export const useCollapsedMonths = () => {
  const [collapsedMonths, setCollapsedMonths] = useState(() => {
    // Load from localStorage
    const stored = localStorage.getItem('planner_collapsed_months');
    return stored ? JSON.parse(stored) : {};
  });

  // Save to localStorage whenever collapsedMonths changes
  useEffect(() => {
    localStorage.setItem('planner_collapsed_months', JSON.stringify(collapsedMonths));
  }, [collapsedMonths]);

  const toggleCollapse = (monthKey) => {
    setCollapsedMonths((prev) => ({
      ...prev,
      [monthKey]: !prev[monthKey] // Toggle: if undefined, becomes true (collapsed by default)
    }));
  };

  return {
    collapsedMonths,
    toggleCollapse
  };
};
